import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import {getMonthNameById } from '../services/MyCollections';
import { Grid } from '@mui/material';

export default function ApproveForPaymentDialog({ open, handleClose, handleApproveForPayment, month, year, accountantName, supervisorName, date, netPriceSummary}) {

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Zatwierdzenie do wypłaty"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Box sx={{ m: '16px' }} />
                        Zatwierdzam do wypłaty zestawienie księgowej / księgowego <br/><br/>
                        <strong>{accountantName}</strong> za okres <strong>{getMonthNameById(month)} {year}</strong><br /><br />
                        Kwota: <strong>{netPriceSummary}</strong> PLN netto <strong>ZGADZA SIĘ</strong> z fakturą
                        <Box sx={{ m: '40px' }} />
                        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                Data: <i>{date}</i>
                            </Grid>
                            <Grid item xs={6}>
                                Podpis: <strong><i>{supervisorName}</i></strong>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" variant="outlined" onClick={handleClose}>Anuluj</Button>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ m: 2, position: 'relative' }}>
                            <Button
                                variant="contained"
                                onClick={handleApproveForPayment}
                            >
                                Zatwierdź
                            </Button>
                        </Box>
                        <Box sx={{ m: 2, position: 'relative' }}>
                        </Box>
                    </Box>
                </DialogActions>
            </Dialog>
        </div>
    );
}